import React, { useMemo } from "react";
import { floral } from "@thebouqs/system";
import { ChevronLeftIcon as LeftArrowIcon, ChevronRightIcon as RightArrowIcon } from "@thebouqs/icons";
import { IconButton } from "@thebouqs/button";
export var ArrowButton = _ref => {
  var {
    direction,
    size,
    onClick,
    ariaLabel = ''
  } = _ref;
  var Icon;
  var arrowStyle = {};

  if (direction === "left") {
    Icon = LeftArrowIcon;
    Object.assign(arrowStyle, {
      left: 0
    });
  } else {
    Icon = RightArrowIcon;
    Object.assign(arrowStyle, {
      right: 0
    });
  }

  return /*#__PURE__*/React.createElement(IconButton, {
    tabIndex: -1,
    "aria-label": ariaLabel,
    sx: arrowStyle,
    size: size,
    onClick: onClick,
    variant: "solid",
    colorScheme: "blackAlpha",
    icon: /*#__PURE__*/React.createElement(Icon, {
      width: "full",
      height: "full"
    })
  });
};
export var ArrowNavigation = _ref2 => {
  var {
    size,
    jump,
    sx
  } = _ref2;
  return /*#__PURE__*/React.createElement(floral.div, {
    className: "carousel-nav",
    sx: sx
  }, /*#__PURE__*/React.createElement(ArrowButton, {
    direction: "left",
    ariaLabel: "move carousel left",
    onClick: () => jump(-1),
    size: size
  }), /*#__PURE__*/React.createElement(ArrowButton, {
    direction: "right",
    ariaLabel: "move carousel right",
    onClick: () => jump(1),
    size: size
  }));
};
export var DotNavigation = _ref3 => {
  var {
    count,
    goTo,
    current,
    sx
  } = _ref3;
  var buttons = useMemo(() => {
    var dots = [];

    var _loop = function _loop(i) {
      dots.push( /*#__PURE__*/React.createElement("li", {
        key: "dot-nav-" + i
      }, /*#__PURE__*/React.createElement(floral.button, {
        onClick: () => goTo(i),
        className: current === i ? 'active' : '',
        tabIndex: -1
      })));
    };

    for (var i = 0; i < count; i++) {
      _loop(i);
    }

    return dots;
  }, [count, current, goTo]);
  return /*#__PURE__*/React.createElement(floral.ul, {
    className: "dot-nav",
    sx: sx
  }, buttons);
};
//# sourceMappingURL=CarouselNavigation.js.map